
import { Suspense, lazy } from 'react';
import { Helmet } from 'react-helmet';
import { Header } from '@/components/landing/Header';
import { Hero } from '@/components/landing/Hero';

// Lazy load components that are below the fold
const HowItWorks = lazy(() => import('@/components/landing/HowItWorks'));
const Pricing = lazy(() => import('@/components/landing/Pricing'));
const FAQ = lazy(() => import('@/components/landing/FAQ'));
const Footer = lazy(() => import('@/components/Footer'));

const METADATA = {
  title: 'IELTS With AI - AI-Powered Essay Feedback | Prepare for IELTS',
  description: 'Improve your IELTS writing score with our AI-powered essay feedback system. Practice Task 1 and Task 2, get instant feedback, and track your progress.'
} as const;

const MainContent = () => (
  <div className="container mx-auto max-w-6xl px-0">
    <Suspense fallback={<div className="h-32" />}>
      <HowItWorks />
      <Pricing />
      <FAQ />
    </Suspense>
  </div>
);

const Index = () => {
  return (
    <div className="min-h-screen bg-stone-50 dark:bg-stone-950 font-inter">
      <Helmet>
        <title>{METADATA.title}</title>
        <meta name="description" content={METADATA.description} />
        <meta property="og:title" content={METADATA.title} />
        <meta property="og:description" content={METADATA.description} />
        <meta name="twitter:title" content={METADATA.title} />
        <meta name="twitter:description" content={METADATA.description} />
      </Helmet>

      <Header />
      <Hero />
      <MainContent />

      <Suspense fallback={<div className="h-16" />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
